export function getHostUrl() {
  const hostname = window.location.hostname;
  if (hostname.includes('localhost')) {
    return `http://${hostname}:3000`;
  }
  return `https://${hostname}`;
}
